import { DateHelperService } from 'app/providers/helpers/helpers';

export interface ScheduleModel {
    date: Date;
    dayCompleted: boolean;
    scheduleRows: ScheduleRange[];
}

export class ScheduleRange {
    start: Date;
    end: Date;
    availability: number; // 0 taken, 1 available

    private dateHelper: DateHelperService = new DateHelperService();

    constructor(start: Date, end: Date, availability: number = 0) {
        this.start = start;
        this.end = end;
        this.availability = availability;
    }

    /**
     *
     * @param availability Valid numbers 0 or 1 (taken/available)
     */
    setAvailability(availability: number): void {
        if (availability == 0 || availability == 1) {
            this.availability = availability;
        } else {
            console.error(
                'setAvailability: invalid number. Only allows 0 or 1.'
            );
        }
    }

    /**
     * Given an ScheduleRange array check if current range
     * is available or not.
     * @param blockedRanges
     * @param gap in minutes
     */
    checkAvailability(blockedRanges: ScheduleRange[], gap: number = 0): void {
        for (let range of blockedRanges) {
            if (this.isBetween(range, gap)) {
                this.setAvailability(0);
                break;
            }
        }
    }

    /**
     * Checks if dates are between other ScheduleRange
     * @param range
     */
    isBetween(range: ScheduleRange, gap: number = 0): boolean {
        let end = gap == 0 ? this.end : this.dateHelper.addTime(this.end, gap);

        return (
            (this.start >= range.start && this.start < range.end) ||
            (end > range.start && end <= range.end) ||
            (this.start < range.start && end > range.end)
        );
    }
}
